<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn search-picker">
                <div class="search-ctn-left">
                    <div class="search-name">仓库</div>
                    <el-select v-model="searchData.SId" @visible-change="getWarehouse" class="search-item" size="small" filterable clearable remote>
                        <el-option v-for="optionItem in warehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                            ><span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span></el-option
                        >
                    </el-select>
                    <div class="search-name">供应商</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.EntpCusName"
                        remote
                        filterable
                        allow-create
                        placeholder="请输入供应商名称"
                        :remote-method="querySearch"
                        v-select-scroll-more="searchSupplierLoad"
                    >
                        <el-option v-for="item in supplierOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"> </el-option>
                    </el-select>
                    <div class="search-name">退货单号</div>
                    <el-input
                        class="search-item"
                        size="small"
                        v-model.trim="searchData.ReturnCode"
                        v-filter-special-char="searchData.ReturnCode"
                        placeholder="请输入退货单号"
                    ></el-input>
                    <div class="search-name">采购单号</div>
                    <el-input
                        class="search-item"
                        size="small"
                        v-model.trim="searchData.OrderCode"
                        v-filter-special-char="searchData.OrderCode"
                        placeholder="请输入采购单号"
                    ></el-input>
                    <div class="search-name">物流状态</div>
                    <el-select class="search-item" size="small" v-model="searchData.State">
                        <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">提交时间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button v-if="permission.scanPurOut" title="扫码出仓" size="small" class="search-btn" type="warning" @click="scanOut()">{{
                        permission.scanPurOut
                    }}</el-button>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    border
                    :header-cell-style="{ background: '#F2F6FC' }"
                    @selection-change="handleSelectionChange"
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; cursor: pointer"
                    highlight-current-row
                    @cell-dblclick="handleDBClick"
                    :tableCode="tableCode"
                    :summary-method="getSummaries"
                    show-summary
                >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <template v-for="(col,index) in columnShowSets">
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-if="col.ColumnCode == 'OrderCode'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <el-button @click="gotoSalesDetails(scope.row)" type="text" size="large">{{ scope.row.OrderCode }}</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else
                        >
                        </el-table-column>
                    </template>
                    <el-table-column label="操作" fixed="right" :autoWidth="true" :isCanSet="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button
                                    v-if="permission.buyReturnOut && !scope.row.IsDelivery && scope.row.WarehouseType != 1"
                                    @click="gotoDetails(6, scope.row)"
                                    type="text"
                                    size="small"
                                    >{{ permission.buyReturnOut }}</el-button
                                >
                                <el-button
                                    v-if="permission.scanPurOut && !scope.row.IsDelivery && scope.row.WarehouseType != 1"
                                    title="扫码出仓"
                                    size="mini"
                                    type="text"
                                    @click="scanOut(scope.row)"
                                    >{{ permission.scanPurOut }}</el-button
                                >
                                <el-button v-if="permission.checkLabels" title="查看标签" size="mini" style="color: orange" type="text" @click="showLabelDetails(scope.row)">查看标签</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                    v-if="tableDataLength != 0"
                ></el-pagination>
            </div>
        </div>     
            <el-dialog :close-on-click-modal="false" title="查看标签" :visible.sync="showLabelsDialog" width="1200px" append-to-body>
                <div class="dialog-content" v-if="showLabelsDialog">
                    <checkOrderLabels @closeDialog="closeLabelsDialog" :OrderId="orderId"></checkOrderLabels>
                </div>
            </el-dialog>   
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import checkOrderLabels from '@/components/business/purManage/checkPROrderLabels.vue';
import breadcrumb from '@/components/common/breadcrumb';
import Vue from 'vue';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn,
        checkOrderLabels
    },
    data() {
        return {
            columnShowSets: [],
            tableCode: 'PROrderOutTable',
            dateTimes: [],
            multipleSelection: null,
            tableData: [],
            orderId:'',
            showLabelsDialog: false,
            options: [],
            warehouseList: [],
            searchData: {
                State: '5',
                EntpCusName: '',
                ReturnCode: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                page: 1, // 当前页数
                limit: 15 // 每页限制条数
            },
            tableDataLength: 0,
            permission: {},
            dialogFormVisible: false,
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未出仓', Value: '5' },
                { Text: '部分出仓', Value: '10' },
                { Text: '已出仓', Value: '15' }
            ],
            // 用于供应商列表，分页搜索功能
            supplierOptions: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
        this.doLayout('multipleTable');
    },
    created() {
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.getTableData();
        this.querySearch();
        this.permission = this.$util.getPermission('purchasesReturnsTakeOut');
        this.$util.setEnterEvent(this, this.$route.fullPath);
    },
    methods: {
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 跳转到关联采购单
        gotoSalesDetails(row) {
            this.$router.push(`/purchaseManage/purchaseOrders/edit_v2?type=1&id=${row.EntpCusPOId}`);
        },
        // 跳转订单详情
        gotoDetails(type, item) {
            let PReturnId = item ? item.PReturnId : '';
            let EntpCusPOId = item ? item.EntpCusPOId : '';
            this.$router.push(`/inventoryManage/purchasesReturns/takeOut/edit?type=${type}&PReturnId=${PReturnId}&id=${EntpCusPOId}`);
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpPurReturnOrder/GetSupPReturnOrderOutWHList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        resetSearch() {
            this.searchData = {
                State: '',
                EntpCusName: '',
                ReturnCode: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                page: 1, // 当前页数
                limit: this.commonPageSize // 每页限制条数
            };
            this.dateTimes = [];
            // this.searchSupplier('');
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                this.gotoDetails(1, event);
            }
        },
        // 获取供应商列表
        querySearch(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit).then(data => {
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = this.$util.uniqueArr(this.supplierOptions, data);
            });
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.querySearch();
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        getWarehouse() {
            if (this.warehouseList.length == 0) {
                this.$util.getWarehouse().then(data => {
                    this.warehouseList = data;
                });
            }
        },
        scanOut(item) {
            if (item && item.PReturnId) this.$router.push(`/inventoryManage/purReturn/scanOut?oid=${item.PReturnId}`);
            else this.$router.push(`/inventoryManage/purReturn/scanOut`);
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (column.property == 'OrderCode' || column.property == 'Creator' || column.property == 'SName' || column.property == 'PayTypeName') {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let strL = sums[index] + '';
                    if (strL.indexOf('.') > -1) {
                        let str = strL.split('.')[1];
                        if (str.length > 2) {
                            sums[index] = sums[index].toFixed(2);
                        }
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
         //关闭订单弹出层
         closeLabelsDialog() {
            this.orderId = '';
            this.showLabelsDialog = false;
        },
        // 打印
        showLabelDetails(row) {
            if (row) {
                this.orderId = row.PReturnId;
                this.showLabelsDialog = true;
            } else {
                this.$util.warningMsg('请选择单据进行查看');
                return;
            }
        },   
    }
};
</script>
